import http from '~/http/cryptomat';

export default ({
  state: {
    rentersList: [],
    rentersNames: [],
  },

  mutations: {
    SET_RENTERS_LIST(state, data) { state.rentersList = data; },
    SET_RENTERS_NAMES(state, data) { state.rentersNames = data; },
  },

  actions: {
    async loadRenters({ commit }, data) {
      const response = await http.post('/api/Renters', { ...data });
      const { Renters, RentersNames, pages } = response.data;
      commit('SET_RENTERS_LIST', Renters);
      commit('SET_RENTERS_NAMES', RentersNames);
      if (pages) {
        commit('SET_PAGES', pages);
      }
    },

    async createRenter(__store, payload) {
      const res = await http.post('/api/Renters/CreateRenter', payload);
      return !res?.data?.error;
    },
  },

  namespaced: true,
});
